// src/components/PageWrapper.jsx
import { motion } from "framer-motion";

// const variants = {
//   initial: {
//     opacity: 0,
//     y: 16,
//   },
//   animate: {
//     opacity: 1,
//     y: 0,
//   },
//   exit: {
//     opacity: 0,
//     y: -16,
//   },
// };

const variants = {
  initial: { opacity: 0, x: 40 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -40 },
};
const transition = {
  duration: 0.3,
  ease: "easeOut",
};

export function PageWrapper({ children }) {
  return (
    <motion.div
      style={{ height: "100%" }}
      initial="initial"
      animate="animate"
      exit="exit"
      variants={variants}
      transition={transition}
    >
      {children}
    </motion.div>
  );
}
